<template>
	<div class="pui-form">
		<minstmarcaje-modals :modelName="modelName"></minstmarcaje-modals>
		<!--<pui-form-header
			v-if="modelLoaded"
			:showHeader="!isCreatingElement">
			<minstmarcaje-form-header
				:modelPk="modelPk"
			></minstmarcaje-form-header>
		</pui-form-header>-->
		<v-form class="mb-4 pb-4" ref="form" v-model="valid" lazy-validation @submit.prevent v-if="modelLoaded">
			<v-layout wrap class="pui-form-layout">
				<v-flex xs12 md12>
					<pui-field-set :title="getTitleDatos">
						<v-layout wrap>
							<!-- IDINSTMARCA -->
							<v-flex xs12 md1>
								<pui-text-field
									:id="`idinstmarca-minstmarcaje`"
									v-model="model.idinstmarca"
									:label="$t('minstmarcaje.idinstmarca')"
									disabled
									toplabel
									maxlength="10"
								></pui-text-field>
							</v-flex>
							<!-- CODINSMARCAEDI -->
							<v-flex xs12 md1>
								<pui-text-field
									:id="`codinsmarcaedi-minstmarcaje`"
									v-model="model.codinsmarcaedi"
									:label="$t('minstmarcaje.codinsmarcaedi')"
									:disabled="formDisabled"
									required
									toplabel
									maxlength="3"
								></pui-text-field>
							</v-flex>
						</v-layout>
						<v-layout wrap>
							<!-- NAME -->
							<v-flex xs12 md12>
								<pui-text-field
									:id="`name-minstmarcaje`"
									v-model="model.name"
									:label="$t('minstmarcaje.name')"
									:disabled="formDisabled"
									required
									toplabel
									maxlength="300"
								></pui-text-field>
							</v-flex>
						</v-layout>
						<v-layout wrap>
							<!-- FECBAJA -->
							<v-flex xs12 md3>
								<pui-date-field
									:id="`fecbaja-minstmarcaje`"
									v-model="model.fecbaja"
									:label="$t('minstmarcaje.fecbaja')"
									:disabled="formDisabled"
									toplabel
									time
								></pui-date-field>
							</v-flex>
						</v-layout>
						<!-- MINI AUDIT -->
						<pui-form-mini-audit class="pl-2" :model="model" v-if="!isCreatingElement"></pui-form-mini-audit>
					</pui-field-set>
				</v-flex>
			</v-layout>

			<!-- Page Footer -->
			<pui-form-footer v-if="!isModalDialog">
				<pui-form-footer-btns
					:formDisabled="formDisabled"
					:saveDisabled="saving"
					:saveAndNew="saveAndNew"
					:saveAndUpdate="saveAndUpdate"
					:save="save"
					:back="back"
				></pui-form-footer-btns>
			</pui-form-footer>
		</v-form>
		<pui-form-loading v-else></pui-form-loading>
	</div>
</template>

<script>
import {PuiFormMethodsMixin} from '@Pui9Components';
import minstmarcajeActions from './MinstmarcajeActions';
import minstmarcajeModals from './MinstmarcajeModals.vue';

export default {
	name: 'minstmarcaje-form',
	mixins: [PuiFormMethodsMixin],
	components: {
		'minstmarcaje-modals': minstmarcajeModals
	},
	data() {
		return {
			modelName: 'minstmarcaje',
			actions: minstmarcajeActions.formActions
		};
	},
	methods: {
		afterGetData() {
			// Do something after get data from server
		}
	},
	computed: {
		getTitleDatos() {
			return this.$t('form.minstmarcaje');
		}
	},
	created() {}
};
</script>
